var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TheToastContainer'),(!_vm.profile.isLoading)?_c('router-view'):_c('BaseLoading',{attrs:{"is-full-page":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }